import authService from '@/services/auth';

export const verifyAdminBypass = async (authContext) => {
  if (!authContext.isAuthenticated) {
    return false;
  }

  try {
    const adminStatus = await authService.isAdmin(true);


    if (adminStatus) {
      return true;
    }
  } catch (error) {
    console.error('[Router] Error verificando admin:', error);
  }

  return false;
};

export const adminGuard = (to, authContext) => {
  if (to.meta.requiresAdmin && !authContext.isAdmin) {
    return '/account/orders';
  }

  return null;
};
